/**
 * @file reducers/RightRail/reducer.js
 */

import { createSlice } from "@reduxjs/toolkit";
import { reduceContent } from "../../utils/dataTransform";

export const rightRailState = (payload = {}) => {
    return {
        path: payload.path || "",
        banner: payload.banner || "",
        defaultHeadlineImage: payload.defaultHeadlineImage || "",
        widgets: payload.widgets || [],
    };
};

const rightRailSlice = createSlice({
    name: "rightRail",
    initialState: rightRailState(),
    reducers: {
        set_right_rail: {
            reducer: (state, action) => {
                return {
                    ...state,
                    ...rightRailState(action.payload),
                };
            },
            prepare: (payload) => {
                if (!payload) {
                    return { payload: {} };
                }
                return {
                    payload: {
                        ...payload,
                        widgets: payload.widgets.reduce(reduceContent, []),
                    },
                };
            },
        },

        reset_right_rail: (state) => {
            return {
                ...state,
                ...rightRailState(),
            };
        },
    },
});

export const { set_right_rail, reset_right_rail } = rightRailSlice.actions;

export default rightRailSlice.reducer;
